import { render, staticRenderFns } from "./DistributeSettingsForm.vue?vue&type=template&id=b4bb08ca"
import script from "./DistributeSettingsForm.vue?vue&type=script&lang=js"
export * from "./DistributeSettingsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports